import { useEffect, useState } from "react";
import BuscaVazaia from "../components/buscavazia/buscaVazia";
import FooterBar from "../footer/footerBar";
import Navbar from "../navbar/navbar";
import Loading from "../components/loading/Loading";
import { Link } from "react-router-dom";
import SRI_pagination from "../components/pagination/pagination";
import api from "../../services/api";
import { vhostV1 } from "../funcoes";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { Box, Button, Container, Fade, Grid, InputAdornment, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, Modal, TableRow, CircularProgress, Paper, IconButton , Dialog,
  DialogContent,  DialogTitle, DialogActions, Divider, 
  Chip} from '@mui/material';
import { Search, Folder } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"


function Ncm(){
         const [load,setLoad] = useState(false);
         const [texto,setTexto] = useState('');
         const [busca,setBusca] = useState("");
         const [ncms,setNcms] = useState([]);
         const [sResult,setSresult] = useState(0);
         const [nPag,setnPag] = useState(1);
         const [totalPaginas,setTotalPaginas] = useState(0);
         const [att, setAtt] = useState(false);
         const [success, setSuccess] = useState(false);
         const [totalNcms, setTotalNcms] = useState(0);

         const [ncm,setNcm] = useState('');
         const [st,setST]                       = useState('');
         const [stOut,setSTOut]                 = useState('');
         const [icms_in,setIcms_in]             = useState(0);
         const [icms_out,setIcms_out]           = useState(0);
         const [icmsSub,setIcmsSub]             = useState(0);
         const [cfop_in,setCfop_in]             = useState('');
         const [cfop_out,setCfop_out]           = useState('');
         const [cest,setCest]                   = useState('');
         const [cstpc,setCstpc]                 = useState('');
         const [cstpcEntrada,setCstpcEntrada]   = useState(0);
         const [pisCredito,setPisCredito]       = useState(0);
         const [cofinsCredito,setCofinsCredito] = useState(0);
         const [pisDebito,setpisDebito]         = useState(0);
         const [cofinsDebito,setCofinsDebito]   = useState(0);
         const [natReceita,setNatReceita]       = useState('');
         const [cclass_trib, setCclass_trib]   = useState('');
         const [produto, setProduto] = useState("");
         const [loading, setLoading] = useState(false);

         const [showModal, setShowModal] = useState(false);

         let config = {
           headers: {
         'Authorization': localStorage.getItem("token")
         }
      }

      function truncarComReticencias(texto, limite) {
        if (!texto) return '';
        return texto.length > limite
       ? texto.substring(0, limite - 3) + '...'
       : texto;
       }

          function handlePageChange(value){
      if(value === "&laquo;" || value === '... '){
        setnPag(1);
      }else if (value === "&lsaquo;" ){
        if (nPag !== 1){
          setnPag(nPag -1);
        }
      }else if(value === "&rsaquo;"){
        setnPag(nPag +1);        
      }else if(value === "&raquo;" || value === ' ...' ){
        setnPag(totalPaginas);        
      }else{
        setnPag(value);
      }    
     
     }

     useEffect(function(){
        api.post(vhostV1('webcash/ncm/listar'),{
            busca: busca,
            pagina: nPag,
            regPag: 10
        },config)
        .then(function(response){
            
            if(response.data.result === 1){
                setSresult(response.data.result);
                setTotalPaginas(response.data.quantidadeDePaginas);
                setNcms(response.data.dados);
                setTotalNcms(response.data.quantidadeTotal);
            }

            
        }).catch(function(err){
            console.log(err);
            
        })
     },[busca, nPag, att]);

     function openModal(e){
        console.log(e);
        
        pesquisaNcm(e);
        setShowModal(true);

     }

     

     function pesquisaNcm(e){
         
           api.post(vhostV1('webcash/produto/ncm'), {
               loja: localStorage.getItem('loja'),
               empresa: 0,
               seq: Number(e)       
             },config)
             .then(function (response) {
                 console.log(response) 


                 setProduto(response.data.dados.PRODUTO);
                 setNcm(response.data.dados.NCM);
                 setST(response.data.dados.ST);
                 setSTOut(response.data.dados.ST_OUT);
                 setIcms_in(response.data.dados.ICMS_IN);
                 setIcms_out(response.data.dados.ICMS_OUT);
                 if(response.data.dados.ICMS_SUB !== null){
                   setIcmsSub(response.data.dados.ICMS_SUB);
                 }
                
                 setCfop_in(response.data.dados.CFOP_IN);
                 setCfop_out(response.data.dados.CFOP_OUT);
                 setCest(response.data.dados.CEST);                   
                 setCstpc(response.data.dados.CSTPC);
                 setCstpcEntrada(response.data.dados.CSTPC_ENTRADA);
                 setPisCredito(response.data.dados.PERCPISCRED);
                 setCofinsCredito(response.data.dados.PERCCOFINSCRED);
                 setpisDebito(response.data.dados.PERCPISCRED);
                 setCofinsDebito(response.data.dados.PERCCOFINSCRED);
                 setNatReceita(response.data.dados.NAT_RECEITA);   
                 setCclass_trib(response.data.dados.CCLASS_TRIB); 
                          
             });
       }

const AtualizandoModal = ({ open, success, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
        }
      }}
      TransitionComponent={Fade}
    >
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          py={3}
        >
          {!success ? (
            <>
              <CircularProgress color="primary" size={48} />
              <Typography variant="body1" mt={3} color="text.secondary">
                Atualizando dados, por favor aguarde...
              </Typography>
            </>
          ) : (
            <>
              <CheckCircleOutlineIcon
                color="success"
                sx={{ fontSize: 60, mb: 1 }}
              />
              <Typography variant="h6" gutterBottom color="success.main">
                Atualização concluída!
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Os dados foram atualizados com sucesso.
              </Typography>
              <Button
                variant="contained"
                color="success"
                onClick={onConfirm}
                sx={{ mt: 3, borderRadius: 2, px: 4 }}
              >
                OK
              </Button>
            </>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

 function handleConfirm() {
  setAtt(!att);
  setSuccess(false);
 }

       const carregarDados = async () => {
    setLoading(true);
    try {
      // 1. Chamada para API externa com Basic Auth
      const apiResponse = await axios.get(
        'https://app.sriservicos.com/SRiIntegradorISAPI.dll/api/v1/listancm/PE',
        {
          auth: {
            username: 'sri',
            password: 'wtgz135xy'
          }
        }
      );

      const dadosExternos = apiResponse.data.data;
      console.log(dadosExternos);
      
      
      

      

      await api.post(vhostV1('webcash/ncm/atualizar'), dadosExternos, config)
      .then(function(response){
        console.log(response);
        
      }).catch(function(error){
        console.log(error);
        
      })
       
    } catch (error) {
      console.error('Erro:', error);
      alert('Erro ao atualizar dados. Verifique o console.');
    } finally {
      setLoading(false);
      setSuccess(true);
    }
  };




  return <div>
         <Navbar/> 
             <Container maxWidth="lg">
      <Box my={4}>
        {/* Título da página */}
         <Box mt={5} mb={3} pt={5}>
      <Typography
        variant="h4"
        sx={{ color: 'primary.main' }}
      >
        Lista de NCM
      </Typography>
    </Box>

    {/* BOTÃO E PESQUISA NA MESMA LINHA */}
    <Box
  display="flex"
  justifyContent="space-between"
  alignItems="center"
  flexWrap="wrap"
  gap={2}
  mb={2}
>
  {/* Botão Atualizar + Total */}
  <Box display="flex" alignItems="center" gap={2}>
    <Button
      variant="contained"
      color="primary"
      onClick={carregarDados}
      startIcon={<Folder />}
      sx={{ boxShadow: 3 }}
    >
      Atualizar
    </Button>

    {/* Total de NCMs */}
    <Chip
      label={`Total NCMs: ${totalNcms}`}
      color="primary"
      sx={{
    height: 33,
    borderRadius: 2,
    px: 2,
    '& .MuiChip-label': {
      fontSize: '1.1rem', // 🔹 força o tamanho do texto
      padding: 0
    }
  }}
    />
  </Box>

  {/* Campo de Pesquisa */}
  <TextField
    variant="outlined"
    label="Pesquisar"
    value={texto}
    onChange={(e) => setTexto(e.target.value)}
    InputProps={{
      endAdornment: (
        <InputAdornment position="end">
          <IconButton onClick={() => setBusca(texto)} color="primary">
            <Search />
          </IconButton>
        </InputAdornment>
      ),
    }}
    sx={{
      flexGrow: 1,
      minWidth: 250,
      maxWidth: 500,
      borderRadius: 2,
      "& .MuiOutlinedInput-root": { height: 50 },
      "& .MuiInputLabel-root": { fontSize: '1.2rem' },
      "& .MuiInputBase-input": { fontSize: '1.1rem' },
    }}
  />
</Box>

        
        {load && (
          <Box display="flex" justifyContent="center" my={4}>
            <CircularProgress />
            <Typography variant="h6" ml={2}>
              Atualizando dados...
            </Typography>
          </Box>
        )}

        
        {sResult === 1 ? (
          <TableContainer component={Paper} sx={{ boxShadow: 3, borderRadius: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: "14px" }}>NCM</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '14px' }}>DESCRIÇÃO</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '14px'  }}>ST</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '14px'  }}>CFOP</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '14px'  }}>CEST</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '14px'  }}>CLASS. TRIB</TableCell>
                  <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '14px'  }}>AÇÕES</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* Substitua ncms por seu array de NCMs */}
                {ncms.map((ncm) => (
                  <TableRow key={ncm.SEQ}>
                    <TableCell sx={{ fontFamily: 'Nunito, sans-serif', fontWeight: 400, fontSize: '12px' }} align="center">{ncm.NCM}</TableCell>
                    <TableCell sx={{ fontFamily: 'Nunito, sans-serif', fontWeight: 400, fontSize: '12px' }} align="center">{truncarComReticencias(ncm.PRODUTO, 90)}</TableCell>
                    <TableCell sx={{ fontFamily: 'Nunito, sans-serif', fontWeight: 400, fontSize: '12px' }} align="center">{ncm.ST}</TableCell>
                    <TableCell sx={{ fontFamily: 'Nunito, sans-serif', fontWeight: 400, fontSize: '12px' }} align="center">{ncm.CFOP_IN}</TableCell>
                    <TableCell sx={{ fontFamily: 'Nunito, sans-serif', fontWeight: 400, fontSize: '12px' }} align="center">{ncm.CEST}</TableCell>
                    <TableCell sx={{ fontFamily: 'Nunito, sans-serif', fontWeight: 400, fontSize: '12px' }} align="center">{ncm.CCLASS_TRIB}</TableCell>
                    <TableCell sx={{ fontFamily: 'Nunito, sans-serif', fontWeight: 400, fontSize: '12px' }} align="center">
                      <Button value={ncm.SEQ} onClick={(e) => openModal(e.target.value)} variant="outlined" color="primary" size="small">
                        Visualizar
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography variant="h6" align="center" mt={4}>
            Nenhum resultado encontrado
          </Typography>
        )}

            <AtualizandoModal open={loading || success} success={success} onConfirm={handleConfirm} />
            
              
           <Dialog open={showModal} onClose={() => setShowModal(false)} maxWidth="lg" fullWidth>
  <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <Typography variant="h6">Detalhes do NCM</Typography>
    <IconButton onClick={() => setShowModal(false)}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers >
    <Grid container spacing={3}>
    <Grid item xs={12}>
    <Paper variant="outlined" sx={{ p: 2, minWidth: 600, maxWidth: 700}}>
      <Box sx={{ display: 'flex', gap: 1 }}>
  <TextField
    label="Código"
    value={ncm}
    InputProps={{ readOnly: true }}
     sx={{ minWidth: 120, maxWidth: 200,
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }, }}
  />
  <TextField
    label="Produto"
    value={produto}
    InputProps={{ readOnly: true }}
   sx={{
    minWidth: 460,
    maxWidth: 480,
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    },
  }}
  />
</Box>
    </Paper>
  </Grid>
          {/* ICMS */}
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom>ICMS</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                  <TextField label="Origem" fullWidth value={String(st)[0] || ''} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="ST Dentro" fullWidth value={st} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="ST Fora" fullWidth value={stOut !== "" ? stOut : "0000"} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="ICMS Dentro UF" fullWidth value={`${icms_in !== null ? icms_in : 0}%`} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="ICMS Fora UF" fullWidth value={`${icms_out !== null ? icms_out : 0}%`} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px',
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="ICMS Substituto" fullWidth value={icmsSub ?? 0} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* CFOP e CEST */}
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom>CFOP / CEST</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                  <TextField label="CFOP Dentro UF" fullWidth value={cfop_in} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="CFOP Fora UF" fullWidth value={cfop_out} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField label="CEST" fullWidth value={cest} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* PIS / COFINS */}
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom>PIS / COFINS</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={2}>
                  <TextField label="Saída CST" fullWidth value={cstpc} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="Aliq. PIS Débito" fullWidth value={`${pisDebito !== null ? pisDebito : 0}%`} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="Aliq. COFINS Débito" fullWidth value={`${cofinsDebito !== null ? cofinsDebito : 0}%`} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="CST Entrada" fullWidth value={cstpcEntrada} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="Aliq. PIS Crédito" fullWidth value={`${pisCredito !== null ? pisCredito : 0}%`} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField label="Aliq. COFINS Crédito" fullWidth value={`${cofinsCredito !== null ? cofinsCredito : 0}%`} InputProps={{ readOnly: true }} sx={{
    "& .MuiInputLabel-root": {
      fontSize: '18px', 
    }}}/>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Receita */}
          <Grid item xs={12}>
  <Paper variant="outlined" sx={{ p: 2 }}>
    <Typography variant="subtitle1" gutterBottom>
      Natureza da Receita
    </Typography>
    <Grid container spacing={2}>
      {/* Campo natReceita */}
      <Grid item xs={12} sm={2}>
        <TextField
          label="Código"
          fullWidth
          value={natReceita}
          InputProps={{ readOnly: true }}
          sx={{
            "& .MuiInputLabel-root": {
              fontSize: "18px",
            },
          }}
        />
      </Grid>

      {/* Campo cclass_trib */}
      <Grid item xs={12} sm={3}>
        <TextField
          label="Class. Trib."
          fullWidth
          value={cclass_trib}
          onChange={(e) => setCclass_trib(e.target.value)}
          sx={{
            "& .MuiInputLabel-root": {
              fontSize: "18px",
            },
          }}
        />
      </Grid>
    </Grid>
  </Paper>
</Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setShowModal(false)} variant="contained" color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>

  
        <div className="row mt-5">
            <SRI_pagination totalPage={totalPaginas} 
                            page={nPag} 
                            limit={10} 
                            siblings={1}
                            onPageChange={handlePageChange}/>
            </div>

            </Box>
 
       </Container> 
       
       <FooterBar/> 
           
     </div> 
 
}

export default Ncm;